export default `
  query listOrganisations {
    listOrganisations {
      id
      name
      userId
      adminAllowedAiVersions
      allowedAiVersions
      defaultAiVersion
      orgType
      pocName
      pocEmail
      licenseStartDate
      licenseEndDate
      licensedSeats
      accountStatus
      accountNotes
      deletedAt
      user {
        id
        firstname
        lastname
      }
      projects {
        id
      }
      createdAt
      updatedAt
    }
  }
`
